// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bc701c86","455":"5ceec694","644":"e3a622d3"}[chunkId] + ".chunk.js";
};